const SPECIFICATION_TYPES = [
  { label: "Living", value: "living" },
  { label: "Bedroom", value: "bedroom" },
  { label: "Master Bedroom", value: "masterbedroom" },
  { label: "Kitchen", value: "kitchen" },
  { label: "Toilet", value: "toilet" },
  { label: "Maindoor", value: "maindoor" },
  { label: "Internal Door", value: "internaldoor" },
  { label: "Toilet Door", value: "toiletdoor" },
  { label: "Balcony Door", value: "balconydoor" },
  { label: "Window", value: "window" },
  { label: "Internal Paint", value: "internalpaint" },
  { label: "External Paint", value: "externalpaint" },
  { label: "Cp fittings", value: "cpfittings" },
  { label: "Sanitaryware", value: "sanitaryware" },
  { label: "Additional Features", value: "additionalfeatures" },
  { label: "Construction Technology", value: "constructionTechnology" },
  { label: "Roads", value: "roads" },
];

export default SPECIFICATION_TYPES;
